import { Typography, Box, Container, Paper } from "@mui/material";
import { RestaurantMenu, Schedule, LocalDining } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import React from "react";

const Header = () => {
    const { t } = useTranslation();
    
    return (
        <Container maxWidth="lg" sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
            <Paper elevation={3} sx={{ 
                p: { xs: 2, sm: 3, md: 4 }, 
                borderRadius: 2, 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
            }}>
                <Box sx={{ textAlign: 'center', color: 'white' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                        <RestaurantMenu sx={{ fontSize: { xs: 24, sm: 32, md: 40 }, mr: 1 }} />
                        <Typography 
                            variant="h3" 
                            component="h1" 
                            sx={{ 
                                fontWeight: 'bold',
                                fontSize: { xs: '1.5rem', sm: '2.5rem', md: '3rem' }
                            }}
                        >
                            {t('app.title')}
                        </Typography>
                        <LocalDining sx={{ fontSize: { xs: 24, sm: 32, md: 40 }, ml: 1 }} />
                    </Box>
                    
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            mb: 3, 
                            opacity: 0.9,
                            fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }
                        }}
                    >
                        {t('app.subtitle')}
                    </Typography>
                    
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        gap: { xs: 2, sm: 3 }, 
                        flexWrap: 'wrap',
                        flexDirection: { xs: 'column', sm: 'row' }
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Schedule sx={{ fontSize: { xs: 20, sm: 24 } }} />
                            <Typography 
                                variant="body1"
                                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                            >
                                {t('app.features.weeklyPlanning')}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <RestaurantMenu sx={{ fontSize: { xs: 20, sm: 24 } }} />
                            <Typography 
                                variant="body1"
                                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                            >
                                {t('app.features.recipeManagement')}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LocalDining sx={{ fontSize: { xs: 20, sm: 24 } }} />
                            <Typography 
                                variant="body1"
                                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                            >
                                {t('app.features.groceryLists')}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default Header;